import _ from 'lodash'
import { PROPOSAL_PHASE_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'
import { INFO } from '../../../../../constants/globalTypes'
import {
  PROPOSAL_TYPE_NAME,
  EXTRA_MODEL
} from '../../../../../constants/proposalTypes'
import { HyperLink } from '../../../../Common/Form'
import PrefixBlock from '../../PrefixBlock'

const checkIsExtraModelExist = listing => {
  const isExtraModelExist = _.some(
    [
      EXTRA_MODEL.COMPLIMENTARIES,
      EXTRA_MODEL.SELECT_COMPLIMENTARIES,
      EXTRA_MODEL.ADDITIONAL_PURCHASE
    ],
    extraModelkey => !_.isEmpty(
      _.get(listing, extraModelkey.value)
    )
  )
  return isExtraModelExist
}

const ExtraModelPrefixBlock = props => {
  const {
    proposalType,
    listing
  } = props
  const isExtraModelExist = checkIsExtraModelExist(listing)
  if (!isExtraModelExist) {
    return null
  }

  const listingId = _.get(listing, 'id')
  const url = `/proposal/${proposalType}/${PROPOSAL_PHASE_TYPE.COMPOSE}`
  const proposalTypeName = PROPOSAL_TYPE_NAME[proposalType]

  return (
    <PrefixBlock
      type={INFO}
      className='extraModel'
    >
      {`批次${proposalTypeName}暫不提供贈品、加購購修改，請使用單筆`}
      <HyperLink
        target='_blank'
        href={`${url}?listingId=${listingId}`}
      >
        {proposalTypeName}
      </HyperLink>
    </PrefixBlock>
  )
}

export default ExtraModelPrefixBlock
